var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "left", attrs: { span: 20 } },
            [
              _c("el-tree", {
                ref: "tree",
                attrs: {
                  "default-expand-all": true,
                  "expand-on-click-node": false,
                  data: _vm.treeData,
                  props: _vm.defaultProps,
                  "check-strictly": true,
                  "node-key": "id",
                  "show-checkbox": "",
                },
                on: { "check-change": _vm.handleCheckChange },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }